import { createSearchParams as rawCreateSearchParams } from 'react-router';
import { notNil } from '../../../core/helpers/is-nil';

/**
 * More generic version of `createSearchParams` from `react-router` that allows for numbers as values.
 * @param init
 */
export const createSearchParams = (
  init: Record<string, number | string | string[] | undefined | null>,
): URLSearchParams => {
  const values = Object.entries(init)
    .map(([key, value]) => (typeof value === 'number' ? [key, `${value}`] : [key, value]))
    .filter(([, value]) => notNil(value));

  return rawCreateSearchParams(Object.fromEntries(values));
};
